export class TipoFornecedor {
  static CFC = '63680567-3B19-4200-9A96-071CDCD1BF60';
  static Aluno = 'CEFAB22F-BE8D-4138-B94F-5346DAF080D7';
  static Clinica = '6999BC5A-23A8-4565-AAB2-7590D1B92071';
  static Outros = 'D21F6C36-C519-4ACF-8815-80F9BF2CBCC2';
  static Laboratorio = 'AF0DCD73-3BFC-4652-863B-B5923D494443';
  static Detran = '3B96FC17-F1B2-437F-B1C1-D51AC33D1ED8';
  static Banco = 'CDDA364B-E28E-45F7-9486-18081C988894';
}



// WEBPACK FOOTER //
// ./src/app/models/tipoFornecedor.ts